import { useState } from "react";
import { api } from "../lib/api";

interface Props {
  groupId: string;
}

/** A puzzle iframe that opted into skipping exposes a global skip_puzzle(). */
interface SkippableWindow extends Window {
  skip_puzzle?: () => void;
}

/**
 * The "Skip puzzle" and "Get a clue" links written on the paper note, matching
 * the original #skip_button (top-left) and #clue_button (top-right).
 */
export function Controls({ groupId }: Props): React.ReactElement {
  const [busy, setBusy] = useState(false);

  const askClue = async () => {
    setBusy(true);
    const res = await api.askForClue(groupId);
    setBusy(false);
    // A successful clue arrives via the clue_disclosed socket event (ClueModal).
    if (res.success !== 1) alert(res.error_message);
  };

  const skip = () => {
    if (!confirm("This will skip the current puzzle. Are you sure?")) return;
    for (const id of ["secondary_external_puzzle_screen", "external_puzzle_screen"]) {
      const frame = document.getElementById(id) as HTMLIFrameElement | null;
      const win = frame?.contentWindow as SkippableWindow | null;
      if (win?.skip_puzzle) {
        win.skip_puzzle();
        return;
      }
    }
    alert("Sorry, only puzzle segments are skippable.");
  };

  return (
    <>
      <button id="skip_button" onClick={skip}>
        Skip puzzle
      </button>
      <button id="clue_button" onClick={() => void askClue()} disabled={busy}>
        Get a clue
      </button>
    </>
  );
}
